/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import {
  getConnectionInfo,
} from 'legacy/containers/ApiUrls';

// Constants Types
import {
  PATIENT_CONNECTION_INFO_REQUEST,
  PATIENT_CONNECTION_INFO_SUCCESS,
  PATIENT_CONNECTION_INFO_FAILURE,
} from './types';

// ------------------------------------
// Actions
// ------------------------------------

export const patientConnectionInfoRequest = () => ({
  type: PATIENT_CONNECTION_INFO_REQUEST,
});
export const patientConnectionInfoSuccess = data => ({
  type: PATIENT_CONNECTION_INFO_SUCCESS,
  payload: data,
});
export const patientConnectionInfoFailure = err => ({
  type: PATIENT_CONNECTION_INFO_FAILURE,
  payload: err,
});

// GET the Connection Info by passing the paticipant ID]
export const handlePatientConnectionInfo = (idtfConnectionId) => (
  dispatch,
  getState,
) => {
  dispatch(patientConnectionInfoRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
  .then(() => {
    return Promise.all([
      dispatch(getConnectionInfo(idtfConnectionId)),
    ]);
  })
    .then(data => {
      if (data[0].errors) {
        dispatch(patientConnectionInfoFailure(data[0].errors));
      } else {
        dispatch(patientConnectionInfoSuccess(data[0]))
      }
    })
    .catch(err => {
      return dispatch(patientConnectionInfoFailure(err))
    });
};



// WEBPACK FOOTER //
// ./src/views/state/PatientConnectionInfo/PatientConnectionInfoActions.js